module.exports = __webpack_public_path__ + "img/34.18cec3b6.jpg";